<a class="pr-xxsmall-y cf" [finLink]="linkUrl$" (click)="navigate($event)">
  <span class="float-left nordic-blue-900-text">{{ offer.name }}</span>
  <span class="float-right heather-700-text bold-type"
    >{{ price$ | async | finPrice }}
    <fcom-icon class="nordic-blue-900-text mr-xxsmall-l ir-xsmall" name="arrow-right"></fcom-icon
  ></span>
</a>
